import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import algoliaSearch from 'algoliasearch/lite';
import { Configure, connectStateResults } from 'react-instantsearch-core';
import { InstantSearch } from 'react-instantsearch-dom';
export { InstantSearch } from 'react-instantsearch-dom';
import { findResultsState } from 'react-instantsearch-dom/server';
import { useAlgoliaConfig } from './AlgoliaConfig.js';
import { AlgoliaConfigProvider } from './AlgoliaConfigProvider.js';
import VirtualFacets from './components/VirtualFacets/VirtualFacets.js';

function AlgoliaSearch({ children  }) {
    const { algoliaInstantSearchProps , isEnabled , facetingAfterDistinct  } = useAlgoliaConfig();
    return /*#__PURE__*/ React__default.createElement(InstantSearch, swcHelpers.extends({}, algoliaInstantSearchProps), /*#__PURE__*/ React__default.createElement(VirtualFacets, null), /*#__PURE__*/ React__default.createElement(Configure, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), /*#__PURE__*/ React__default.createElement(WithStateResults, {
        isEnabled: isEnabled
    }, children));
}
const WithStateResults = connectStateResults((_param)=>{
    var { children , isEnabled  } = _param, stateResults = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "isEnabled"
    ]);
    return children(isEnabled ? stateResults : null);
});
function fetchAlgoliaConfig(props) {
    return _fetchAlgoliaConfig.apply(this, arguments);
}
function _fetchAlgoliaConfig() {
    _fetchAlgoliaConfig = swcHelpers.asyncToGenerator(function*(props) {
        if (!props.isEnabled) {
            return props;
        }
        const { appId , apiKey  } = props.options;
        const searchClient = algoliaSearch(appId, apiKey);
        try {
            return swcHelpers.objectSpread({}, props, {
                resultsState: yield findResultsState((providedProps)=>{
                    return /*#__PURE__*/ React__default.createElement(AlgoliaConfigProvider, swcHelpers.extends({}, props), /*#__PURE__*/ React__default.createElement(InstantSearchContainer, swcHelpers.extends({}, providedProps), /*#__PURE__*/ React__default.createElement(VirtualFacets, null)));
                }, swcHelpers.objectSpread({
                    searchClient
                }, props.options))
            });
        } catch (err) {
            console.log('An error occured while fetching algolia hits');
            console.error(err);
            return swcHelpers.objectSpread({}, props, {
                isEnabled: false
            });
        }
    });
    return _fetchAlgoliaConfig.apply(this, arguments);
}
const InstantSearchContainer = (props)=>{
    const { algoliaInstantSearchProps  } = useAlgoliaConfig();
    return /*#__PURE__*/ React__default.createElement(InstantSearch, swcHelpers.extends({}, algoliaInstantSearchProps, props), props.children);
};

export { AlgoliaSearch, fetchAlgoliaConfig };
//# sourceMappingURL=AlgoliaSearch.js.map
